import SidesheetHeader from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-sidebar/components/sidesheet-header/SidesheetHeader";
import ConfirmModal from "components/confirm-modal";
import useToggleModal from "hooks/useToggleModal";
import messages from "messages";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { closeSidesheet } from "store/calendarSidebarSlice";
import { PRO_CALENDAR_ANALYTICS_PAGE_NAME, track } from "utils/amplitude";
import AddOrEditSession from "../../add-to-calendar/components/add-or-edit-session/AddOrEditSession";

interface EditSessionProps {
  appointment: AppointmentMetaData & {
    appointment_series?: AppointmentSeriesMetaData | undefined;
  } & {
    invoice?: InvoiceData | undefined;
  };
}

const AMPLITUDE_COMPONENT_NAME = "edit-session-sidesheet";

const EditSession = ({ appointment }: EditSessionProps) => {
  const dispatch = useDispatch();
  const [isDirty, setIsDirty] = useState(false);

  const {
    show: shouldShowConfirmCloseModal,
    open: openConfirmCloseModal,
    close: closeConfirmCloseModal,
  } = useToggleModal(false);

  return (
    <>
      <SidesheetHeader
        title={messages.editSession}
        onClose={() => {
          track(
            PRO_CALENDAR_ANALYTICS_PAGE_NAME,
            [AMPLITUDE_COMPONENT_NAME, "close-button"],
            "click",
          );

          if (isDirty) {
            openConfirmCloseModal();
            return;
          }
          dispatch(closeSidesheet());
        }}
      />

      <AddOrEditSession
        currentSession={appointment}
        setIsDirty={setIsDirty}
        hasInitialTime={true}
        initialIntervalStart={appointment.appointment_start}
        isActive={true}
        setShowNewSessionTypeWarningOnCancel={() => {}}
      />

      <ConfirmModal
        show={shouldShowConfirmCloseModal}
        onConfirm={() => {
          closeConfirmCloseModal();
          dispatch(closeSidesheet());
        }}
        onCancel={closeConfirmCloseModal}
        labelTitle={messages.areYouSure}
        labelCancel={messages.keepEditing}
        labelConfirm={messages.continue}
      >
        {messages.yourEditsWontBeSaved}
      </ConfirmModal>
    </>
  );
};

export default EditSession;
